/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Statistics Page
 * API для страницы статистики HR Recruiter. Специально разработан для компонента StatisticsPage.tsx.  ## Что нужно для страницы: 1. Статистические карточки: всего кандидатов, средний балл, активные вакансии 2. Распределение по статусам: успешный, в процессе, провал 3. График активности: кандидаты, интервью, заявки по дням (неделя/месяц) 4. Эффективность рекрутеров: объем, завершено, успешность, качество, в работе 5. Таблица собеседований: кандидат, вакансия, рекрутер, оценка, статус, дата  ## Типы статистики: - `overview` - общая статистика для карточек - `activity` - данные для графика активности - `recruiters` - эффективность рекрутеров - `interviews` - детальная таблица собеседований 
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8080/api/v1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
